import useTheme from "config/useTheme";
import styles from "./TransactionModal.module.css";
import ArrowLeft from "img/explorer_widget/arrow_left.svg";
import CloseIcon from "img/explorer_widget/close_blue.svg";
import DatabaseIcon from "img/explorer_widget/database_icon.svg";
import HexIcon from "img/explorer_widget/hex_icon.svg";
import UnhexIcon from "img/explorer_widget/unhex_icon.svg";
import { useState } from "react";

const TransactionModal = ({ toggle, data }) => {
  const { dark } = useTheme();
  const [actionModal, setActionModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [encrypted, setEncrypted] = useState(true);

  const handleActionModal = () => {
    setActionModal(!actionModal);
  };

  const handleEncryption = () => {
    setEncrypted(!encrypted);
  };

  return (
    <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
      <div className={styles.container}>
        <div
          className={`${styles.modal_top} ${
            actionModal ? styles.actions_modal_top : ""
          }`}
        >
          {actionModal ? (
            <button
              onClick={() => {
                handleActionModal();
                setEncrypted(true);
              }}
            >
              <img src={ArrowLeft} alt="go back" /> go back
            </button>
          ) : (
            ""
          )}
          <button onClick={() => toggle()}>
            <img src={CloseIcon} alt="close" />
          </button>
        </div>
        {!actionModal ? (
          <>
            <div className={styles.modal_header}>
              <p>
                transactionId: <span>{data?.trx?.id}</span>
              </p>
            </div>
            <div className={styles.modal_body}>
              <h6>Actions</h6>
              <div className={styles.actions}>
                {data.trx.transaction.actions.map((action, id) => {
                  return (
                    <button
                      key={id}
                      onClick={() => {
                        handleActionModal();
                        setActionData(action);
                      }}
                    >
                      <span>
                        <img src={DatabaseIcon} alt="db icon" />
                        {action?.account}
                      </span>
                      {action?.name}
                    </button>
                  );
                })}
              </div>
            </div>
          </>
        ) : (
          // Action modal content
          <>
            <div className={styles.action_modal_body}>
              <p>
                <span>code: </span>
                {actionData?.account}
              </p>
              <p>
                <span>name: </span>
                {actionData?.name}
              </p>
              <div className={styles.action_authorisation}>
                <p>authorisation</p>
                {actionData?.authorization.map((auth, index) => (
                  <div
                    key={index}
                    className={styles.action_authorisation__data}
                  >
                    {Object.entries(auth).map(([key, value], id) => (
                      <p key={id}>
                        <span>{key}:</span> {value}
                      </p>
                    ))}
                  </div>
                ))}
              </div>
              <div className={styles.action_main_data}>
                <div className={styles.action_encryption}>
                  <button onClick={() => handleEncryption()}>
                    {encrypted ? (
                      <img src={UnhexIcon} alt="unhex" />
                    ) : (
                      <img src={HexIcon} alt="hex" />
                    )}
                  </button>
                </div>
                <div className={styles.action_encrypted_data}>
                  {encrypted ? (
                    <p>data: {actionData?.hex_data}</p>
                  ) : (
                    <>
                      {/* {Object.entries(actionData?.data).map(([key, value]) => (
                                                    <div key={key}>
                                                        <p><span>{key}:</span> {typeof value === 'object' ? renderObject(value) : value}</p>
                                                    </div>
                                                ))} */}
                      <pre>
                        <p>{JSON.stringify(actionData?.data, null, 4)}</p>
                      </pre>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TransactionModal;
